import EditableGridRow from '../../components/EditableGridRow.vue'
import EditableGridCell from '../../components/EditableGridCell.vue'

export default {
  name: 'DiscountedProductPartialView',

  props: {
    hideStartDate: {
      type: String
    },
    hideEndDate: {
      type: String
    },
    row: Number,
    activeRow: Number,
    activeColumn: Number,
    isBeingEdited: Boolean,
    discount: {
      type: Object,
      required: true
    },
    customerGroups: {
      type: Array,
      required: true
    },
    $v: {
      type: Object,
      required: true
    }
  },

  computed: {
    basePrice () {
      let regularPrice = this.discount.regularPrice
      let regularCustomerGroupPrice = this.discount.regularCustomerGroupPrice

      if (this.discount.customerGroupId === 0) {
        return regularPrice
      } else {
        return regularCustomerGroupPrice
      }
    },

    customerGroupName () {
      return this.customerGroups.reduce((result, customerGroup) => {
        return customerGroup.value === this.discount.customerGroupId ? customerGroup.text : result
      }, '')
    },

    margin () {
      let salesPrice = parseFloat(this.discount.salesPrice)
      let cost = parseFloat(this.discount.cost)

      if (isNaN(cost) || isNaN(salesPrice)) {
        return 0
      }

      if (salesPrice === 0) {
        return 0
      }

      return (salesPrice - cost) / salesPrice * 100
    },

    showDates () {
      return this.hideStartDate !== this.discount.startDate || this.hideEndDate !== this.discount.endDate
    }
  },

  watch: {
    discount: {
      deep: true,
      handler: function (val) {
        this.discount.hasBeenEdited = true
      }
    }
  },

  components: {
    'editable-grid-row': EditableGridRow,
    'editable-grid-cell': EditableGridCell
  },

  methods: {
    deleteDiscount () {
      this.$emit('delete-item', this.discount)
    },

    showProductSelect () {
      this.$emit('product-select', this.discount)
    }
  },

  created () {
    this.$on('activated', (data) => {
      this.$parent.$emit('activated', data)
    })

    this.$on('edit', (data) => {
      this.$parent.$emit('edit', data)
    })
  }
}



// WEBPACK FOOTER //
// ./src/views/EditEvent/DiscountedProduct.js